export function evidenceFresh(sample, now = Date.now(), maxAge = 20000) {
  const collectedAt = Number(sample?.collectedAt);
  return sample?.isStale !== true && Number.isFinite(collectedAt) && collectedAt > 0
    && collectedAt <= now + 2000 && now - collectedAt <= maxAge;
}
